/**
 * Layout для табов главной страницы
 * 
 * Композиция HomeHeader + Outlet на уровне app/ —
 * позволяет избежать горизонтальных импортов между pages
 */

import { useCallback } from 'react';
import { Outlet, useLocation } from 'react-router';
import { HomeHeader, HOME_TABS } from '@/components/home-header';
import { useRouterNavigation, ROUTE_PATHS } from '@/lib';
import type { HomeTabId } from '@/lib';

/**
 * Определяет текущий таб из pathname
 */
function useCurrentTab(): HomeTabId {
  const location = useLocation();
  const path = location.pathname;
  
  if (path === ROUTE_PATHS.HOME_SELECTIONS) return 'selections';
  if (path === ROUTE_PATHS.HOME_POPULAR) return 'popular';
  if (path === ROUTE_PATHS.HOME_WISHLISTS) return 'wishlists';
  return 'feed';
}

export function HomeLayout(): JSX.Element {
  const { switchToHomeFeed, switchToHomeSelections, switchToHomePopular, switchToHomeWishlists } = useRouterNavigation();
  const currentTab = useCurrentTab();

  const handleTabChange = useCallback((tabId: HomeTabId) => {
    switch (tabId) {
      case 'feed':
        switchToHomeFeed();
        break;
      case 'selections':
        switchToHomeSelections();
        break;
      case 'popular':
        switchToHomePopular();
        break;
      case 'wishlists':
        switchToHomeWishlists();
        break;
    }
  }, [switchToHomeFeed, switchToHomeSelections, switchToHomePopular, switchToHomeWishlists]);

  return (
    <div className="flex flex-col bg-background pb-32 overflow-x-hidden min-h-[100dvh]">
      {/* Header с вкладками и уведомлениями */}
      <HomeHeader
        currentTab={currentTab}
        tabs={HOME_TABS}
        onTabChange={handleTabChange}
      />

      {/* Контент подстраниц */}
      <div className="flex-1 flex flex-col">
        <Outlet />
      </div>
    </div>
  );
}